<template>
  <com-page>
    <div class="search_wrapper flex justify-end">
      <el-button type="primary" @click="handleCreated">新增</el-button>
    </div>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #operation="row">
          <el-button type="primary" size="mini" @click="handleEdit(row.data)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDel(row.data)">删除</el-button>
        </template>
      </com-table>
    </com-card>
    <the-add-type ref="createdType" @update="update"></the-add-type>
  </com-page>
</template>

<script>
import { siteTypeApi, delSiteTypeApi } from '@/api/site'
import theAddType from './components/the-add-type'

export default {
  components: { theAddType },
  data() {
    return {
      api: siteTypeApi,
      searchColumns: [
        {
          label: '类型名称',
          prop: 'name',
          type: 'input'
        }
      ],
      columns: [
        {
          label: '类型名称',
          prop: 'name'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ]
    }
  },
  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        row
      }
      this.$refs.createdType.open(params)
    },
    handleCreated() {
      const params = {
        type: 'created'
      }
      this.$refs.createdType.open(params)
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleDel(row) {
      this.$confirm('是否确认删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          delSiteTypeApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.search_wrapper {
  width: 100%;
  padding: 20px;
  background: white;
  margin-bottom: 15px;
  border-radius: 5px;
}
</style>
